import { jsx as n } from "react/jsx-runtime";
import { Icon as e } from "../../../../components/Icon/index.js";
import { ToolbarButton as m } from "../../styles.js";
import { TextSlash as c } from "@pelando/fontawesome/icons";
import { useTranslation as a } from "../../../../hooks/useTranslation/index.js";
function h({ quill: t }) {
  const { t: r } = a("common");
  return /* @__PURE__ */ n(
    m,
    {
      type: "button",
      onClick: () => {
        const o = t == null ? void 0 : t.getSelection();
        t == null || t.removeFormat((o == null ? void 0 : o.index) || 0, (o == null ? void 0 : o.length) || 0);
      },
      title: r("clear-format-button-text"),
      children: /* @__PURE__ */ n(e, { icon: c, "aria-label": r("clear-format-button-text") })
    }
  );
}
export {
  h as ClearFormatButton
};
